@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-folder-state-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [folderState]="_context.formContext.item"
                (folderStateUpdated)="onFolderStateUpdated($event)"
                (canceled)="onCanceled($event)"></app-folder-state-form>
        </mat-tab>
    </mat-tab-group>
}
